{
  "production":"Produção",
  "delay":"Demora",
  "gantt":"Gantt",
  "profile":"Perfil",
  "search":"Buscar",
  "inUser":"Em uso",
  "idle":"Inativo",
  "down":"Desligada",
  "logout":"Sair",
  "email":"E-mail",
  "password":"Senha",
  "rememberMe":"Lembre de mim",
  "signIn":"Entrar",
  "alarms":"Alarmes",
  "factoryDay":"Dia de fábrica",
  "shift":"Turno",
  "crew":"Equipe",
  "from":"Desde",
  "to":"Hasta",
  "range":"Intervalo",
  "filterType":"Tipo de filtro",
  "filter":"Filtro",
  "all":"Tudo",
  "currentWeek":"Semana actual",
  "lastWeek":"Semana anterior",
  "last7Days":"Últimos 7 dias",
  "currentMonth":"Mês atual",
  "lastMonth":"Mês anterior",
  "last30Days":"Últimos 30 dias",
  "realTime": "Tempo real",
  "session": "Sessões",
  "machine": "Máquina",
  "update": "Atualizar",
  "month_1": "Janeiro",
  "month_2": "Fevereiro",
  "month_3": "Março",
  "month_4": "Abril",
  "month_5": "Maio",
  "month_6": "Junho",
  "month_7": "Julho",
  "month_8": "Agosto",
  "month_9": "Setembro",
  "month_10": "Outubro",
  "month_11": "Novembro",
  "month_12": "Dezembro"
}
